import ApplicationController from '../../../javascript/controllers/application_controller'

/**
 * Marks the navbar link for the current page with `aria-current="page"`.
 *
 * A Drive visit renders fresh links, so `connect` covers it. A morphing refresh
 * keeps the element but syncs its attributes to the server markup, which has no
 * active state, so `mark` runs again on `turbo:morph`.
 */
export default class extends ApplicationController {
  connect() {
    this.mark()
  }

  mark() {
    if (new URL(this.element.href).pathname === window.location.pathname) {
      this.element.setAttribute('aria-current', 'page')
    }
  }
}
